import { render, staticRenderFns } from "./CommunityView.vue?vue&type=template&id=c4ba0f58&"
import script from "./CommunityView.vue?vue&type=script&lang=js&"
export * from "./CommunityView.vue?vue&type=script&lang=js&"
import style0 from "./CommunityView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports